/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Typography } from '@mui/material';
import { BrowserView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';


const Testimonies = ( ) => {

    const { classes } = useStyles();
    const { t } = useTranslation();

    const testimoniesList = [
        { title: 'ERC20 and Stellar airdrops', subTitle: ' ', text: 'Knew exactly what was needed and also trained us how to work with it. Others quoted much more time, but Belltane did it quickly.' },
        { title: 'Tokenomics Consulting', subTitle: 'Ben K.  UK', text: 'James was very knowledgeable and we\'d 100% work with him again.' },
        { title: 'Hyperledger Blockchain Consulting – Media / IP ownership', subTitle: ' ', text: 'Contacted James for some strategic guidance. He is extremely knowledgeable on blockchain platforms and the process of developing products to take to market.' },
        { title: 'Hyperledger Fabric Installation', subTitle: 'Director Federal Agency USA', text: 'James is incredible. He was exceptionally helpful in walking me through a complex process of installing specialized software. You will be hiring top notch talent.' },

    ];
    return (
        <>
            <BrowserView>

                <main>
                    <Grid container className={classes.container}>
                        <Grid item xs={12} sm={12} md={12} style={{ margin: '30px' }}>
                            <Typography variant="h2" align="center">
                                {t('titles:happyclients')}</Typography>
                            <div className={classes.sectionTitleBorder}></div>
                            <Typography variant="h3" align="center" style={{ margin: '10px', color: "#748494", lineHeight: '1.75' }} paragraph>

                                {t('descp:testimonies')}

                            </Typography>

                            <Grid container spacing="4" >


                                <Grid item xs={12} sm={12} md={12}>
                                    <Carousel
                                        showArrows={true}
                                        showDolts={false}

                                        infiniteLoop={true}
                                        showThumbs={false}
                                        showStatus={false}
                                        autoPlay={true}
                                        interval={6100}>
                                        {testimoniesList && testimoniesList.map((testimony, index) => (
                                            <div style={{ backgroundColor: 'transparent' }} key={index}>

                                                <div className="myCarousel">
                                                    <Typography variant="h3" style={{ textAlign: "center" }}>{testimony.title}</Typography>
                                                    <Typography variant="h4" align="center">{testimony.subTitle}</Typography>
                                                    <p>{testimony.text}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}

                                    </Carousel>

                                </Grid>


                            </Grid>
                        </Grid>
                    </Grid>
                </main>
            </BrowserView>

        </>
    );
}


const useStyles = makeStyles({ "name": { Testimonies } })((theme) => ({
    root: {
        display: 'flex',
    },

    content: {
        flex: '1 0 auto',
    },


    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        margin: '10px',


        maxHeight: '600px!important',


        position: 'relative',
        zIndex: '9',
        display: 'flex',
        alignItems: 'center',
        height: '100vh',


        "&::before": {
            content: `''`,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: -1,
            background: 'white'
        }
    },
    container: {
        maxHeigh: '500px!important',
        display: 'contents!important',
        padding: '50px!important',
        margin: '50px!important',
        zIndex: '1',
        position: 'relative',
        minHeight: '300px!important',

    },
    bigHeaderTypo: {

        fontSize: '22px!important',
        lineHeight: '1.2!important',
        marginBottom: '40px!important'
    },

    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    sectionTitleBorder: {
        width: '100px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',
        marginBottom: '30px',

    },
    testomniesPara: {
        maxWidth: '500px!important',
        background: '#dce7eb!important',
        borderRadius: '20px!important',
        padding: '40px!important',
        lineHeight: '1.8'
    }
}));

export default Testimonies;